<template>
  <v-container fluid class="overlay" v-if="this.$store.state.ticket.ticket">
    <v-layout align-center justify-center row fill-height>
      <v-flex xl6 md6 sm11 xs11>
        <v-layout row>
          <v-flex>
            <v-flex class="ticketing-machine">
              <v-flex class="ticketing-machine-hole"></v-flex>
            </v-flex>
            <v-card>
              <v-card-title>
                <v-layout column>
                  <v-flex style="margin-bottom:3px;" >
                    <v-layout align-center justify-center row fill-height>
                      <v-flex>
                        <h6 class="text-center font-weight-bold">
                          {{ stripHtml($t(this.$store.state.ticket.ticket_summary)) }}
                        </h6>
                      </v-flex>
                      <v-flex>
                        <v-btn class="close_btn elevation-0" style="float: right;" fab small color="error" @click="backToHomepage">
                          <v-icon dark>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                  </v-flex>
                  <v-flex>
                    <v-data-table
                      :items="ticketInfo"
                      class="elevation-1"
                      hide-actions
                      hide-headers
                      id="ticket-body"
                    >
                      <template v-slot:items="props">
                        <td><b>{{ props.item.key }}</b></td>
                        <td>{{ props.item.value }}</td>
                      </template>
                    </v-data-table>
                  </v-flex>
                  
                  <v-flex heavy-border my-2>
                    <h6 class="text-center font-weight-bold my-1" v-html="$t('code_info')"></h6>
                    <h1
                      class="text-center text-danger font-weight-bold ticket-code"
                    >{{ this.$store.state.ticket.ticket_info.code }}</h1>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-actions>
                  <v-layout align-space-around justify-start column fill-height class="buttons">
                    <v-flex>
                      <v-btn
                        id="clipboard"
                        data-clipboard-target="#ticket-body"
                        @click="copyToClipboard"
                        small
                        :color="this.$vuetify.theme.secondary"
                        block
                      >{{ $t('copy_to_clipboard') }}</v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn block @click="printTicket" small :color="this.$vuetify.theme.accent" id="print">{{ $t('print') }}</v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn :color="this.$vuetify.theme.secondary" small block @click="backToHomepage" id="homepage">{{ $t('back_to_homepage') }}</v-btn>
                    </v-flex>
                  </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ClipboardJS from "clipboard";
import RemoteData from "../../mixins/remotedata";
import Utilities from "../../mixins/utilities";
export default {
  name: "rMessageOverlay",
  methods: {
    backToHomepage: function() {
      this.hideTicket();
      this.$router.push("/");
    },
    printTicket: function() {
      window.print();
    },
    copyToClipboard: function() {
      var element = document.getElementById("clipboard");
      element.classList.add("bg-success");
      element.classList.add("text-white");
    }
  },
  computed: {
    ticketInfo: function() {
      return [
        {
          'key': this.$t('branch_name'),
          'value': this.stripHtml(this.$t(this.$store.state.ticket.ticket_info.branchName))
        },
        {
          'key': this.$t('service_name'),
          'value': this.stripHtml(this.$t(this.$store.state.ticket.ticket_info.serviceName))
        },
        {
          'key': this.$t('ticket_number'),
          'value': this.$store.state.ticket.ticket_info.TicketNumber
        },
        {
          'key': this.$t('appointment_day'),
          'value': this.$store.state.ticket.ticket_info.AppointmentDay + " " + this.$store.state.ticket.ticket_info.AppointmentTime
        }
      ]
    }
  },
  created() {
    new ClipboardJS("#clipboard");
  },
  mixins: [Utilities, RemoteData()]
};
</script>

<style scoped>
.overlay {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(39, 42, 43, 0.8);
  transition: opacity 200ms ease-in-out;
}

.ticketing-machine{
  background-color: lightgray;
  padding: 10px;
  border-radius: 5px 10px;
}

.ticketing-machine-hole{
  width: 100%;
  height: 20px;
  background-color: darkgray;
  padding: 10px;
  border-radius: 10px;
}

.ticketing-machine + .v-card{
  margin-top: -25px;
  margin-left: 20px;
  margin-right: 20px;
}

.bottom-border {
  border-bottom: 1px dotted gray;
}

.heavy-border {
  border: 5px dotted gray;
}

.v-card__title{
  padding-bottom: 0;
}

.v-card__actions{
  padding-top: 0;
}

.buttons div {
  margin-top: 2px;
}

.close_btn{
  margin: 0;
  padding: 0;
  width: 40px;
  height: 40px !important;
}

.row-title {
  font-weight: bold;
}

.row-data {
  text-align: center;
}
.ticket-code {
  margin: 0;
  padding: 0;
}

.v-btn{
  height: auto;
}

.v-btn /deep/ .v-btn__content{
  white-space: pre-line !important;
}

@media only screen and (max-width: 600px) {
  .headline {
    font-size: 15px !important;
  }

  .v-card__title {
    padding: 10px;
    padding-bottom: 0;
  }

  #clipboard,
  #print {
    display: none;
  }
}
</style>

<style>
@media print {
  .overlay {
    background: transparent !important;
  }
  body .v-content,
  body .v-toolbar,
  body .v-footer {
    display: none !important;
  }

  button {
    display: none !important;
  }
}
</style>